import Pagination from '@anm/components/Pagination';
import { memo, FC } from 'react';

import { LoaderMassonry } from '../TemplateListWithScroll/MasonryWrapper';
import TemplateList from '../TemplateListWithScroll/TemplateList';
import { TemplateListProps } from '../TemplateListWithScroll/types';
import useTemplatesPager from '../hooks/useTemplatesPager';

const TemplateListWithPagination: FC<TemplateListProps> = props => {
  const [link, pagesCount, currentPage, canShowLoader, handleLoadMore] = useTemplatesPager();

  return (
    <>
      {canShowLoader ? <LoaderMassonry size="large" color="blue" /> : <TemplateList {...props} />}
      <Pagination {...{ link, pagesCount, currentPage }} onLoadMore={handleLoadMore} />
    </>
  );
};

export default memo(TemplateListWithPagination);
